import axios from '~/common/plugins/axios.js'
export const state = () => ({
  articlesList: [],
  data: [],
  searchParams: {},
  pagination: {
    listName: "文章",
    current: 1,
    page_size: 20,
    total: 1
  }
})

export const mutations = {
  set_articlesList(state, v) {
    state.articlesList = v
  },
  set_data(state, v) {
    state.data = v
  },
  set_searchParams(state, v) { // 缓存搜索参数
    state.searchParams = v
  },
  set_pagination(state, v) {
    state.pagination = v
  },
  set_total(state, v) {
    state.pagination.total = v
  }
}

export const actions = {
  async post_articlesList({commit}, params) {
    if (!params.name) {
      // clear
      commit('set_searchParams', params);
      commit('set_articlesList', []);
      commit('set_pagination', {
        current: 1,
        page_size: 20,
        total: 0
      });
    } else {
      const res = await axios.$post(`/rest/erp/ory/v3/posts/search`, params)
      commit('set_searchParams', params)
      commit('search/set_searchKey', params.name, {root: true}); // todo params.keyword 会改成 params.name
      commit('set_articlesList', Array.isArray(res.data.list) ? res.data.list : [])
      // todo 注意 后台没按格式返回 pagination，后面要他改正
      commit('set_pagination', res.data.pagination)
      return Array.isArray(res.data.list) ? res.data.list : [];
    }
  },
  async getData({commit}, params) {
    // const res = await axios.$post(`/rest/erp/ory/v3/posts/search`, params)
    let data = [
      {
      "id": "5570",
      "state": "1",
      "title": "芯链商城 - 使用指南",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "区块链",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "武汉加油，抗击疫情，有芯在线为您服务！",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "区块链",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "icHub网站上线试运行通告",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "区块链",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "2020放假安排",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "区块链",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "芯链商城 ",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "区块链",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "草稿",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "新年新喜",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "区块链",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "文章使用指南",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "软件开发中心",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    }, {
      "id": "5570",
      "state": "1",
      "title": "开芯",
      "sbu_id": "43712",
      "reads": "238",
      "like": "234",
      "collection": "153",
      "comment_count": "20",
      "update_time": "2020-01-20",
      "published_time": "2020-01-16",
      "user_id": "15943",
      "sbu": "有芯电子",
      "is_top": "1",
      "recommended": "1",
      "is_no1": "0",
      "category_id": "127",
      "state_tag": "发布",
      "category": "软件开发中心",
      "no1_top_recommend": "×√√"
    },
    ];
    commit('set_data', data);
    commit('set_total', data.length);
    // return res;
  },
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
